import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import styled, { ThemeProvider } from 'styled-components';
import StyledIcon from '../../../../../styledComponents/styles/Icon.styled';
import { themeViaForms } from '../../../../../styledComponents/settings/theme';

import { toast } from 'react-toastify';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import DeleteSubmissionTagModal from './DeleteSubmissionTag.modal';

import { AccentButtonMediumNunito, ButtonMediumNunito } from '../../../../../styledComponents/styles/Buttons.styled';
import TextSearch from '../../../../../styledComponents/styles/TextSearch.styled';
import TextInput from '../../../../../styledComponents/styles/TextInput.styled';
import EmojiPicker from '../../../../components/library/emojiPicker';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTagColors,
  createSubmissionTag,
  updateSubmissionTag,
  getAvailableTags,
} from '../../../../../actions/formsActions';
import toastMessageStyles from '../../../../../sites/viaGlobal/components/toastMessage/toastMessage.scss';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';

const FlexContainer = styled.div``;

const Header = styled.h1`
  font-family: Nunito, sans-serif;
  font-style: normal;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  color: #373737;
  margin-top: 15px;
`;

const ChildContainer = styled.div`
  margin-top: 33px;
`;

const Content = styled.div`
  // margin: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
`;

const EditButton = styled.button`
  color: var(--gray-medium3, #666);
  leading-trim: both;
  text-edge: cap;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: 0.056px;
  background-color: transparent;
  border: none;
`;

const TagLabelBox = styled.div`
  display: flex;
  width: 352px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
`;

const TagLabel = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  font-family: Open Sans;
  font-style: normal;
`;
const TagLabelDescription = styled.div`
  color: var(--black, #373737);
  font-family: Open Sans;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  letter-spacing: 0.21px;
  width: 100%;
`;
const TagListBox = styled.div`
  width: 375px;
  height: 212px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow-y: scroll;
  border: 1px solid var(--off-white2, #e7e7e7);
  padding-left: 5px;
`;

const FormWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 390px;
  padding: 25px 14px;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid var(--off-white2, #e7e7e7);
  background: var(--white, #fff);
`;

const InputWrapper = styled.div`
  width: 330px;
  margin-top: 5px;
`;
const InputSearchWrapper = styled.div`
  width: 330px;
  margin-left: 21px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  height: 42px;
  padding: 8px 13px;
  justify-content: right;
  align-items: center;
  gap: 6px;
`;

const FormField = styled.div`
  flex: 1;
  justify-content: flex-start;
`;
const NewTagWrapper = styled.div`
  display: flex;
  width: 375px;
  padding: 14px;
  justify-content: flex-end;
  align-items: center;
`;

const Input = styled.input`
  display: none;
  &:checked + label::before {
    background-color: black;
  }
`;

const FormHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 90px;
  width: 100%;
  justify-content: space-between;
`;
const DeleteWrapper = styled.div`
  color: var(--error-text, #8b1313);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
`;

const Label = styled.label`
  width: 31px;
  height: 31px;
  display: inline-block;
  cursor: pointer;
  margin-right: 14px;
  position: relative;
  border-radius: 4px;
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    border-radius: 4px;
  }
  input:checked + &::after {
    border: 2px solid black;
  }
`;

const DeleteFormLink = styled.div`
  color: #8b1313;
  cursor: pointer;
  font-family: Open Sans, sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-align: end;
  span {
    min-height: 15px;
    display: inline-flex;
    align-items: center;
  }
  svg {
    align-items: center;
    display: inline-flex;
    margin: -2px 5px 0 0;
    min-height: 15px;
  }
`;

const SubmissionTagModal = props => {
  const dispatch = useDispatch();
  const tagNameLength = 30;
  const tagDescriptionLength = 50;
  const availableTags = useSelector(state => state.forms.availableTags);
  const permissions = useSelector(state => state.profile.permissions);
  const [submissionTagColor, setSubmissionTagColor] = useState(8);
  const [selectedEmojis, setSelectedEmojis] = useState('');
  const [tagID, setTagID] = useState('');
  const [tagName, setTagName] = useState('');
  const [tagDescription, setTagDescription] = useState('');
  const [submissionType, setSubmissionType] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const tagColors = useSelector(state => state.forms.tagColors);
  const [availableTagList, setAvailableTagList] = useState([]);
  const [showCreateForm, setShowCreateFrom] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showCreateButton, setShowCreateButton] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTagName, setDeleteTagName] = useState('');
  const [selectedTag, setSelectedTag] = useState(props.applicationTag);

  const schema = yup.object().shape({
    tag_name: yup.string().required('At least 1 character is required'), // Tag Name is mandatory
  });
  
  const { control, handleSubmit, formState, getValues, register, setValue, reset } = useForm({
    shouldUnregister: false,
    resolver: yupResolver(schema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const setAvailableTagData = () => {
    const updateAvailableTags = availableTags?.data?.data.map(item => ({
      ...item,
      attributes: {
        ...item.attributes,
      },
      ['label']: item.attributes.name.toLowerCase(),
    }));
    const availabelSortedTags = _orderBy(updateAvailableTags, 'label', 'asc');
    setAvailableTagList(availabelSortedTags);
  };

  const onSubmitHandler = data => {
    const type = props.submissionType == 'Application' ? 'Application' : 
                props.submissionType == 'Plan Form' ? "Plan Form" : 
                props.submissionType == 'Traveler' ? "User" : 'Form';
    const tags = {
      tags: {
        name: String(data?.tag_name)?.trim(),
        description: data?.tag_description,
        emoji: selectedEmojis,
        tag_color_id: submissionTagColor,
        tag_type: type,
      },
    };
    if (isEdit) {
      dispatch(
        updateSubmissionTag(tags, tagID, (status, message) => {
          if (status) {
            toast(message, {
              type: 'success',
              className: toastMessageStyles['successContainer'],
              toastClassName: toastMessageStyles['wrapper'],
              bodyClassName: toastMessageStyles['successBody'],
              progressClassName: toastMessageStyles['progress-bar'],
              position: 'bottom-right',
            });
            dispatch(getAvailableTags(submissionType==="Traveler" ? "User" : submissionType));
            //props.handleShowTagModal(false);
            //props.onSuccess()
          } else {
            toast(message, {
              type: 'error',
              className: toastMessageStyles['failureContainer'],
              toastClassName: toastMessageStyles['wrapper'],
              bodyClassName: toastMessageStyles['failureBody'],
              progressClassName: toastMessageStyles['progress-bar'],
              position: 'bottom-right',
            });
          }
        }),
      );
    } else {
      dispatch(
        createSubmissionTag(tags, (status, message) => {
          if (status) {
            toast(message, {
              type: 'success',
              className: toastMessageStyles['successContainer'],
              toastClassName: toastMessageStyles['wrapper'],
              bodyClassName: toastMessageStyles['successBody'],
              progressClassName: toastMessageStyles['progress-bar'],
              position: 'bottom-right',
            });
            //props.handleShowTagModal(false);
            dispatch(getAvailableTags(submissionType==="Traveler" ? "User" : submissionType));
            handleNewCreateForm();
            //props.onSuccess()
          } else {
            toast(message, {
              type: 'error',
              className: toastMessageStyles['failureContainer'],
              toastClassName: toastMessageStyles['wrapper'],
              bodyClassName: toastMessageStyles['failureBody'],
              progressClassName: toastMessageStyles['progress-bar'],
              position: 'bottom-right',
            });
          }
        }),
      );
    }
  };

  useEffect(() => {
    setAvailableTagData();
  }, [availableTags]);

  useEffect(() => {
    //setAvailableTagData()
    dispatch(getTagColors());
    const type = props.submissionType == 'Application' ? 'Application' : 
                props.submissionType == 'Plan Form' ? "Plan Form" : 
                props.submissionType == 'Traveler' ? "Traveler" : 'Form';
    setSubmissionType(type);
    setSelectedTag(props.applicationTag);
    if (props.isTagCreateForm === 'create') {
      setShowCreateFrom(true);
      if (props.tagSearchQuery !== '') {
        document.getElementById('tag_name')?.focus();
        setTagName(props.tagSearchQuery);
        setValue('tag_name', props.tagSearchQuery);
      }
    } else {
      setShowCreateFrom(false);
    }
    document.getElementById('tag_name')?.focus();
  }, []);

  const showEditForm = tag => {
    reset();
    setShowCreateFrom(true);
    setIsEdit(true);
    setTagDescription('');
    setTagName(tag.attributes.name);
    setValue('tag_name', tag.attributes.name);
    setSubmissionTagColor(tag.attributes.tag_color.id);
    setSelectedEmojis(tag.attributes.emoji);
    setTagID(tag.id);
    if (tag.attributes.description !== null && tag.attributes.description !== undefined) {
      setTagDescription(tag.attributes.description);
      setValue('tag_description', tag.attributes.description);
    } else {
      setTagDescription('');
      setValue('tag_description', '');
    }
    document.getElementById('tag_name')?.focus();
  };

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('tag_name')?.focus();
    }, 500);
  }, [showCreateForm]);

  const searchTag = value => {
    const updateAvailableTags = availableTags?.data?.data.map(item => ({
      ...item,
      attributes: {
        ...item.attributes,
      },
      ['label']: item.attributes.name.toLowerCase(),
    }));
    const availabelSortedTags = _orderBy(updateAvailableTags, 'label', 'asc');
    if (value.trim() === '') {
      // If the search value is empty, show all available tags
      setAvailableTagList(availabelSortedTags);
    } else {
      const filteredTags = availabelSortedTags.filter(item =>
        item.attributes.name.toLowerCase().includes(value.toLowerCase()),
      );
      setAvailableTagList(filteredTags);
    }
  };

  const handleEmojiSelect = emoji => {
    setShowEmojiPicker(false);
    toggleEmojiPicker();
    //setSelectedEmojis([...selectedEmojis,emoji.emoji]);
    setSelectedEmojis(emoji.emoji);
  };
  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleEmojiDelete = emoji => {
    //const newEmojis = selectedEmojis.filter((e) => e !== emoji);
    setSelectedEmojis('');
  };

  const tagLabel = availableTagList.map(item => {
    const bgColor = item.attributes.tag_color.bg_hex_code;
    const textColor = item.attributes.tag_color.font_hex_code;
    return (
      <TagLabelBox key={`tablabel_${item.id}`}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <TagLabel
            style={{
              backgroundColor: `${bgColor}`,
              color: `${textColor}`,
            }}
            key={`tag_${item.id}`}
          >
            {item.attributes.emoji
              .split(',')
              .join('')
              .trim()}{' '}
            {item.attributes.name}
          </TagLabel>
          <EditButton onClick={() => showEditForm(item)}>
            <StyledIcon type={'Pencil'} color={'#446372'} size={'16px'} />
          </EditButton>
        </div>

        <TagLabelDescription>{item.attributes.description}</TagLabelDescription>
      </TagLabelBox>
    );
  });

  const colorInput = tagColors?.data?.data?.map(tagColor => {
    const bgColor = tagColor.attributes.bg_hex_code;
    const isChecked = tagColor.id == submissionTagColor ? true : false;
    const labelStyle = {
      background: bgColor,
      borderColor: bgColor,
    };
    if (isChecked) {
      labelStyle.borderColor = 'black';
      labelStyle.border = '2px solid';
    }
    return (
      <Label tabIndex={0} style={labelStyle}>
        <Input
          name={'tag_color'}
          onChange={e => setSubmissionTagColor(e.target.value)}
          type="radio"
          checked={isChecked}
          value={tagColor.id}
        />
      </Label>
    );
  });

  const handleDeleteTag = (tagID, tagName) => {
    setTagID(tagID);
    setDeleteTagName(tagName);
    setShowDeleteModal(true);
  };

  const handleNewCreateForm = () => {
    reset();

    setValue('tag_name', '');
    setValue('tag_description', '');
    setTagID('');
    setIsEdit(false);
    setShowCreateFrom(true);
    setTagName('');
    setSubmissionTagColor(8);
    setSelectedEmojis('');
    setTagID('');
    setTagDescription('');
    document.getElementById('tag_name')?.focus();
  };

  return (
    <ThemeProvider theme={themeViaForms}>
      <FlexContainer>
        <Modal
          blockScroll={false}
          open={props.show}
          onClose={() => props.onClose(false)}
          center
          styles={{
            overlay: { background: 'rgba(0, 0, 0, 0.65)' },
            modal: {
              maxWidth: '1000px',
              width: !!props.width ? props.width : '500px',
              height: '100%',
              padding: '0px',
              position: 'fixed',
              right: '0px',
              top: '0px',
              // overflow: 'scroll'
            },
            closeButton: {
              marginTop: '5.8px',
              marginRight: '20.8px',
              width: '24px',
              height: '24px',
            },
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}
          closeIcon={<StyledIcon type="Close" color="#9FABAE" size="24px" />}
        >
          <div style={{ overflow: 'scroll', height: '100%' }}>
            <Header>
              <a
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                onClick={() => props.handleShowTagModal(false, '', selectedTag)}
              >
                <StyledIcon type="Close" color="#373737" size="24px" />
              </a>
              <span style={{ marginLeft: '10px' }}>{submissionType} Tags</span>
            </Header>
            <hr style={{ width: '100%', height: '2px', background: '#D7D7D7' }} />
            <ChildContainer>
              <Content>
                <div className="search-tag-content">
                  <InputSearchWrapper>
                    <TextSearch
                      id={'tagSearchId'}
                      debounceValue={value => searchTag(value)}
                      placeholder={`Search ${submissionType} Tags`}
                      style={{ border: '1px solid #bbb' }}
                    />
                  </InputSearchWrapper>

                  {availableTagList.length > 0 && (
                    <>
                      <TagListBox>
                        {/* tag list label */}
                        {tagLabel}
                      </TagListBox>
                    </>
                  )}
                  {(props.isTagCreateForm === 'edit' || isEdit || showCreateButton) &&
                    permissions.organization_settings.includes('create_edit_delete_tags') && (
                      <NewTagWrapper>
                        <a
                          style={{ cursor: 'pointer' }}
                          arial-label="Create New Tag"
                          onClick={() => handleNewCreateForm()}
                        >
                          <StyledIcon type={'Add'} color={'#446372'} size={'16px'} /> Create Tag
                        </a>
                      </NewTagWrapper>
                    )}
                </div>
                {showCreateForm && (
                  <FormWrapper>
                    <FormHeaderWrapper>
                      <label
                        style={{
                          color: 'var(--black, #373737)',
                          fontFamily: 'Open Sans',
                          fontSize: '18px',
                          fontStyle: 'normal',
                          fontWeight: '600',
                          lineHeight: '16px' /* 88.889% */,
                        }}
                      >
                        {isEdit ? `Edit ${submissionType} Tag` : `Create ${submissionType} Tag`}
                      </label>
                      {isEdit && permissions.organization_settings.includes('create_edit_delete_tags') && (
                        <DeleteWrapper>
                          <DeleteFormLink onClick={() => handleDeleteTag(tagID, tagName)}>
                            <StyledIcon type="Trash" size="16px" color="#8b1313" />
                            <span>Delete</span>
                          </DeleteFormLink>
                        </DeleteWrapper>
                      )}
                    </FormHeaderWrapper>
                    <form id="application-submission-tag" onSubmit={handleSubmit(onSubmitHandler)}>
                      <FormField>
                        <Controller
                          control={control}
                          name={'tag_name'}
                          render={({ field: { onChange, defaultValue, value, name, ref } }) => (
                            <InputWrapper>
                              <TextInput
                                errorMsg={_get(formState.errors.tag_name, 'message') || ''}
                                id={'tag_name'}
                                aria-label="Tag Name"
                                name={'tag_name'}
                                openSans
                                label={`${submissionType} Tag Name`}
                                placeholder={'Enter tag name'}
                                required
                                control={control}
                                errors={formState.errors}
                                isDirty={formState.isDirty}
                                value={value}
                                defaultValue={tagName}
                                getValues={getValues}
                                register={register}
                                onChange={value => {
                                  if (value.target.value.length <= tagNameLength) {
                                    setValue('tag_name', value, {
                                      shouldValidate: true,
                                      shouldDirty: true,
                                      shouldTouch: true,
                                    });
                                    onChange(value);
                                    setTagName(value.target.value);
                                  }
                                }}
                              />
                              <span>{tagNameLength - tagName?.length} Characters Remaining</span>
                            </InputWrapper>
                          )}
                        />
                      </FormField>
                      <div style={{ marginTop: '10px' }}>
                        <EmojiPicker
                          handleEmojiSelect={handleEmojiSelect}
                          handleEmojiDelete={handleEmojiDelete}
                          selectedEmojis={selectedEmojis}
                          toggleEmojiPicker={toggleEmojiPicker}
                          showEmojiPicker={showEmojiPicker}
                        />
                      </div>
                      <FormField>
                        <Controller
                          control={control}
                          name={'tag_description'}
                          render={({ field: { onChange, defaultValue, value, name, ref } }) => (
                            <InputWrapper>
                              <TextInput
                                id="tag_description"
                                aria-label="Tag Description"
                                name="tag_description"
                                label="Tag Description"
                                placeholder="Enter an internal description"
                                control={control}
                                getValues={getValues}
                                register={register}
                                value={value}
                                defaultValue={tagDescription}
                                onChange={value => {
                                  if (value.target.value.length <= tagDescriptionLength) {
                                    setValue('tag_description', value, {
                                      shouldValidate: true,
                                      shouldDirty: true,
                                      shouldTouch: true,
                                    });
                                    onChange(value);
                                    setTagDescription(value.target.value);
                                  }
                                }}
                              />
                              <span>
                                {tagDescriptionLength - (tagDescription ? tagDescription.length : 0)} Characters
                                Remaining
                              </span>
                            </InputWrapper>
                          )}
                        />
                      </FormField>
                      <div style={{ marginTop: '10px' }}>{colorInput}</div>
                      <ButtonWrapper>
                        <ButtonMediumNunito
                          type={'button'}
                          onClick={() => props.handleShowTagModal(false, '', selectedTag)}
                        >
                          Cancel
                        </ButtonMediumNunito>
                        <AccentButtonMediumNunito type="submit" saving={isSaving} form="application-submission-tag">
                          Save Tag
                        </AccentButtonMediumNunito>
                      </ButtonWrapper>
                    </form>
                  </FormWrapper>
                )}
                {showDeleteModal && (
                  <DeleteSubmissionTagModal
                    open={showDeleteModal}
                    onClose={() => {
                      setShowDeleteModal(false);
                    }}
                    onSuccess={tagId => {
                      const updatedTags = availableTagList.filter(item => item.id !== tagId);
                      setAvailableTagList(updatedTags);
                      setTagID('');
                      setIsEdit(false);
                      setDeleteTagName('');
                      setShowCreateFrom(false);
                      setShowCreateButton(true);
                      dispatch(getAvailableTags(submissionType==="Traveler" ? "User" : submissionType));
                    }}
                    tagId={tagID}
                    tagName={deleteTagName}
                    submissionType={submissionType==="Traveler" ? "User" : submissionType}
                  />
                )}
              </Content>
            </ChildContainer>
          </div>
        </Modal>
      </FlexContainer>
    </ThemeProvider>
  );
};

export default SubmissionTagModal;
